import { Icons, Loading } from '@commenda/kakashi';

const IncorporationFormPreLoadingPage = ({
  error,
  onSignOut,
}: {
  error?: { status: number };
  onSignOut: () => void;
}) => {
  console.log(error);
  return (
    <main>
      <header className="px-2xl txt-large-bold h-16 flex w-full justify-end items-center border">
        <div
          className="h-8 w-8 flex justify-center items-center shrink-0 cursor-pointer group hover:bg-bg-primary rounded-md transition"
          onClick={onSignOut}
        >
          <Icons.LogOut01 className="size-4 text-button-tertiary-fg group-hover:text-button-tertiary-fg-hover" />
        </div>
      </header>
      <div className="min-h-[calc(100vh-64px)] flex flex-col items-center justify-center">
        {error?.status === 401 ? (
          <div className="flex flex-col gap-4 items-center">
            <Icons.Lock01 className="size-8 text-button-tertiary-fg" />
            <div>
              <p> You don't have access to this page.</p>
              <p> Try logging in with another account.</p>
            </div>
          </div>
        ) : (
          <Loading />
        )}
      </div>
    </main>
  );
};

export default IncorporationFormPreLoadingPage;
